export const reducer = (state: any, action: any): any => {
    switch (action.type) {
        case 'LOGIN_POPUP_STARTED':
            return {
                ...state,
                isLoading: true,
            };
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return {
                ...state,
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined,
            };
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
            if (state.user === action.user) {
                return state;
            }
            return {
                ...state,
                isAuthenticated: !!action.user,
                user: action.user,
            };
        case 'LOGOUT':
            return {
                ...state,
                isAuthenticated: false,
                user: undefined,
            };
        case 'ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
    }
};
